export default __webpack_public_path__ + "static/img-cs-zappi-timeline--mobile-3f773877288d3b3073eb1c88e935ed22.png";